// src/utils/leadConversation.js
// Merge a lead's texts (textMessages docs), sent emails (emailrecepts docs),
// and logged activities into ONE newest-first timeline for the lead drawer's
// Conversation view. Pure; rendering decides how each kind looks.

export function mergeConversation({ texts = [], emails = [], activities = [] }) {
  const items = [
    ...texts.map((t) => ({
      kind: "text",
      id: `t_${t.id}`,
      at: t.createdAt || 0,
      direction: t.direction === "inbound" ? "inbound" : "outbound",
      body: t.body || "",
    })),
    ...emails.map((e) => ({
      kind: "email",
      id: `e_${e.id}`,
      at: Number(e.id) || 0,
      subject: e.subject || "(no subject)",
      email: e,
    })),
    ...activities.map((a, i) => ({
      kind: "activity",
      id: `a_${a.id ?? `${a.at}_${i}`}`,
      at: a.at || 0,
      type: a.type || "Note",
      note: a.note || "",
      byName: a.byName || "",
    })),
  ];
  return items.sort((x, y) => (y.at || 0) - (x.at || 0));
}
